import { Directive, Input, OnChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[formValidatorsYearInputValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: YearInputValidatorDirective,
      multi: true,
    },
  ],
  standalone: true,
})
export class YearInputValidatorDirective implements Validator, OnChanges {
  private _onChange: () => void;
  @Input() public minYear: number;
  @Input() public maxYear: number;

  public validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    if (isNaN(control.value)) {
      return {
        isNaN: true,
      };
    }

    let toValidate;
    if (typeof control.value === 'string') {
      toValidate = parseInt(control.value, 10);
    } else {
      toValidate = control.value;
    }

    if (this.minYear && toValidate < this.minYear) {
      return {
        minYear: true,
      };
    }
    if (this.maxYear && toValidate > this.maxYear) {
      return {
        maxYear: true,
      };
    }

    return null;
  }

  public registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  ngOnChanges(): void {
    if (this._onChange) {
      this._onChange();
    }
  }
}
